import GameCardModel from '../GameCardModel/GameCardModel';
import {games} from './GamesDetails';
import './Home.css';

function Welcome () {
    return (
        <div class="welcome" > 
            <h1 className='welcome_title'>Bienvenue sur MLG !</h1>
            <p>Vous trouverez sur notre plateforme des jeux classiques et indémodables, appréciés des gamers de tout âge. Nous proposons essentiellement des jeux de réflexion, de mémoire, d'anticipation et de logique.</p> 
        </div> 
    );
}

export default function Home () { 
    return (
        <section> 
            <Welcome/>
            <div className='game_list'>
               {games.map((game, i) => <GameCardModel 
                    picture={game.picture} 
                    url={game.url}
                    styleToApply={{
                        // height: '13rem',
                        // width: '13rem',
                        marginInline: '10px',
                        borderRadius: '0.6rem',
                        border: 'solid'
                    }}
                />)} 
            </div>
        </section>
    );
}